import { render, staticRenderFns } from "./SubmenuWithSubmenus.vue?vue&type=template&id=a782bdd0&scoped=true&"
import script from "./SubmenuWithSubmenus.vue?vue&type=script&lang=js&"
export * from "./SubmenuWithSubmenus.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a782bdd0",
  null
  
)

export default component.exports